<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
    
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  async created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="scss">

</style>
